import { select } from 'd3-selection'
import { bhaLength } from './calculateBHA'
import { ScaleLinear, ScaleTime } from 'd3'
import { IBHA } from './types'

const components = {
    'Drill String': 'drill-string',
    Stabilizer: 'spiral-stabilizer',
    // "Turbine":"",
    // "PWD":"",
    Sub: 'drill-collar',
    RSS: 'rotary-steerable-system',
    'Heavy-weight Drill Pipe': 'drill-pipe',
    'Drilling Jar': 'drilling-jars',
    'Reamer / Underreamer': 'under-reamer',
    'MWD / LWD': 'mwd',
    'Drill pipe': 'drill-pipe',
    'Drill collar': 'non-mag-drill-collar',
    'Drill Bit': 'bit-pdc',
    'Down Hole Motor': 'motor'
}

async function loadDefs() {
    const data = await fetch('/content/plugin-drilling-widgets/svg/bha.svg')
    const svg = await data.text()

    return svg
}

async function getDEFs(): Promise<SVGDefsElement> {
    const svg = await loadDefs()

    const div = document.createElement('div')
    div.innerHTML = svg

    return div.querySelector('defs')
}

export default class BHAComponent {
    async render(
        scale: ScaleTime<number, number> | ScaleLinear<number, number>,
        svg: HTMLDivElement | null,
        BHAs: IBHA[],
        bitDepth: number
    ): Promise<void> {
        if (svg && Array.isArray(BHAs)) {
            const defs = await getDEFs()
            const s = select(svg)

            // TODO: move as a external definition?
            if (s.select('defs').empty()) {
                s.append('defs').html(defs.innerHTML)
            }

            s.selectAll('defs symbol')
                .nodes()
                .forEach((node: HTMLElement) => {
                    if (Object.values(components).indexOf(node.id) === -1 && node.id !== 'undefined') {
                        console.log('(!) The symbol ' + node.id + " isn't mapped")
                    }
                })

            const length = bhaLength(BHAs)
            const sca = scale.clamp(false) as ScaleTime<number, number> | ScaleLinear<number, number>

            // drill-string
            select(svg)
                .selectAll('g.drill-string')
                .data([null])
                .join('g')
                .classed('drill-string', true)
                .selectAll('use')
                .data([null])
                .join('use')
                .attr('xlink:href', '#drill-string')
                .attr('height', Math.max(0, sca(bitDepth - length)))

            // bha
            select(svg)
                .selectAll('g.bha')
                .data([null])
                .join('g')
                .classed('bha', true)
                // .attr("transform", `translate(0 ${scale(bitDepth)})`)
                .selectAll('use')
                .data(BHAs)
                .join('use')
                .attr('xlink:href', d => '#' + components[d.component_type])
                .attr('component_type', d => d.component_type)
                .attr('height', d => Math.max(0, sca(d.bottom) - sca(d.top)))
                .attr('transform', d => `translate(0 ${sca(d.top)})`)
        }
    }
}
